var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dividerDirection')
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.optionModel.direction),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "direction", $$v)
      },
      expression: "optionModel.direction"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "horizontal",
      "value": "horizontal"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "vertical",
      "value": "vertical"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e85511c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-divider/divider-direction-editor.vue
// module id = null
// module chunks = 